import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { getPersonName, useSlsStateContext, getNestedOrFloatingElementById } from '@fs/zion-sls'
import SimpleRelationshipsList from './SimpleRelationshipsList'

const RemoveHouseholdMemberDialogOverlay = ({ overlay, personId, onSave = () => {} }) => {
  const [t] = useTranslation()
  const { images } = useSlsStateContext()

  const person = useMemo(() => getNestedOrFloatingElementById(images, personId), [personId, images])

  const handleCancel = useCallback(() => {
    overlay.close()
  }, [overlay])

  return (
    <DialogOverlay {...overlay} title={t('remove-from-household-dialog.title', 'Remove Household Member')}>
      <SimpleRelationshipsList
        person={person}
        topElement={
          <Paragraph size="sm">
            {t(
              'remove-from-household-dialog.remove-relationships-message',
              '{personName} will be put in a new household and the following relationships will be removed:',
              {
                personName: getPersonName({ person }),
              }
            )}
          </Paragraph>
        }
        emptyContent={
          <Paragraph size="sm">
            {t(
              'remove-from-household-dialog.remove-relationships-empty-message',
              '{personName} will be put in a new household.',
              {
                personName: getPersonName({ person }),
              }
            )}
          </Paragraph>
        }
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="low" onClick={handleCancel} data-testid="remove-from-household-dialog-cancel-button">
            {t('remove-from-household-dialog.cancelBtn', 'Cancel')}
          </Button>
          <Button
            emphasis="high"
            color="danger"
            onClick={onSave}
            data-testid="remove-from-household-dialog-remove-button"
          >
            {t('remove-from-household-dialog.removeBtn', 'Remove')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}

RemoveHouseholdMemberDialogOverlay.propTypes = {
  overlay: PropTypes.shape({
    open: PropTypes.func,
    close: PropTypes.func,
    isOpen: PropTypes.bool,
  }).isRequired,
  personId: PropTypes.string.isRequired,
  onSave: PropTypes.func,
}

export default RemoveHouseholdMemberDialogOverlay
